import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import {
  faAddressBook,
  faComments,
  faInfoCircle,
  faTags,
  faTruckLoading,
  faMoneyBill,
  faVideo,
  faPodcast,
  faFileInvoice,
  faTruckFast,
  faVoicemail,
  faGear,
  faSun
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToasts } from "react-toast-notifications";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Form, Modal, Row, Col, Button, Spinner } from "react-bootstrap";
import { MdOutlineFiberNew } from "react-icons/md";
import Swal from "sweetalert2"

// Constans import
import useWindowDimensions from "../../helpers/useWindowDimensions";
import CommisionPage from "./settingSalePage/CommisionPage";
import { UPDATE_SHOP } from "../../graphql/shop/mutation";
import { SHOP } from "../../graphql/shop/queryShop";
import { GET_SETTING_BY_SHOP } from "../../graphql/setting/query";
import LoadingSpinner from "../../components/LoadingSpinner";

function Settings() {
  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const { width } = useWindowDimensions();
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [isOpen, setIsOpen] = useState(false);
  const [affiliateEnabled, setAffiliateEnabled] = useState(false)
  const [typeCommission, setTypeCommission] = useState(true)
  const [isModalForm, setIsModalForm] = useState(false);
  const [shopDetail, setShopDetail] = useState({});

  const [getShopData, { data: shopData, loading: loadingShop }] = useLazyQuery(
    SHOP,
    { fetchPolicy: "network-only" }
  );

  // setting by shop
  const { data: settingData, refetch: fetchSettingData } = useQuery(GET_SETTING_BY_SHOP, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        shop: shopId,
      },
    },
  });


  const [updateShop, { loading: updateShopLoading }] = useMutation(UPDATE_SHOP);

  useEffect(() => {
    fetchShopInfo();
  }, [shopId]);

  const fetchShopInfo = () => {
    getShopData({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };

  useEffect(() => {
    if (shopData?.shop) {
      setShopDetail(shopData?.shop);
      setAffiliateEnabled(shopData?.shop?.isUseInflu)
      setTypeCommission(shopData?.shop?.isTypeCommission)
      fetchSettingData()
    }
  }, [shopData]);

  // const _handleSwitchService = async () => {
  //   try {
  //     if (updateShopLoading) return;
  //     setShopDetail({
  //       ...shopDetail,
  //       commissionService: shopDetail?.commissionService ? false : true,
  //     });
  //     await updateShop({
  //       variables: {
  //         data: {
  //           commissionService: shopDetail?.commissionService ? false : true,
  //         },
  //         where: {
  //           id: shopId,
  //         },
  //       },
  //     });
  //   } catch (error) {
  //     addToast("ເກີດຂໍ້ຜິດພາດ!", {
  //       appearance: "error",
  //       autoDismiss: true,
  //     });
  //   }
  // };

  // const _handleSwitchAffiliate = async () => {
  //   try {
  //     if (updateShopLoading) return;
  //     setShopDetail({
  //       ...shopDetail,
  //       commissionAffiliate: shopDetail?.commissionAffiliate ? false : true,
  //     });
  //     await updateShop({
  //       variables: {
  //         data: {
  //           commissionAffiliate: shopDetail?.commissionAffiliate ? false : true,
  //         },
  //         where: {
  //           id: shopId,
  //         },
  //       },
  //     });
  //   } catch (error) {
  //     addToast("ເກີດຂໍ້ຜິດພາດ!", {
  //       appearance: "error",
  //       autoDismiss: true,
  //     });
  //   }
  // };

  // // ສະຫລັບການເປີດ - ປີດ ການນຳໃຊ້ affiliate ສຳລັບຮ້ານ
  // const handleCancelInflu = async () => {
  //   try {
  //     // if (updateShopLoading) return;

  //     const res = await updateShop({
  //       variables: {
  //         data: {
  //           isUseInflu: false,
  //         },
  //         where: {
  //           id: shopId,
  //         },
  //       },
  //     });
  //     if (res) {
  //       fetchShopInfo();
  //     }
  //   } catch (error) {
  //     addToast("ເກີດຂໍ້ຜິດພາດ!", {
  //       appearance: "error",
  //       autoDismiss: true,
  //     });
  //   }
  // };

  // const handleUpdateShop = async () => {
  //   try {
  //     if (updateShopLoading) return;
  //     const res = await updateShop({
  //       variables: {
  //         data: {
  //           isUseInflu: true,
  //           isTypeCommission: true
  //         },
  //         where: {
  //           id: shopId,
  //         },
  //       },
  //     });
  //     if (res) {
  //       fetchShopInfo();
  //     }
  //   } catch (error) {
  //     addToast("ເກີດຂໍ້ຜິດພາດ!", {
  //       appearance: "error",
  //       autoDismiss: true,
  //     });
  //   }
  // };


  // Alternative version with more flexible typeCommission options

  const handleUpdateShop = async () => {
    try {
      if (updateShopLoading) return;

      let updateData = {
        isUseInflu: affiliateEnabled,
        isTypeCommission: typeCommission,
      };

      const res = await updateShop({
        variables: {
          data: updateData,
          where: {
            id: shopId,
          },
        },
      });

      if (res?.data?.updateShop) {
        fetchShopInfo();
        addToast("ອັບເດດຮ້ານຄ້າສຳເລັດ!", {
          appearance: "success",
          autoDismiss: true,
        });
        setIsOpen(false)
      }
    } catch (error) {
      console.error("Error updating shop:", error);
      addToast("ເກີດຂໍ້ຜິດພາດໃນການອັບເດດຮ້ານຄ້າ!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const onCloseModalForm = () => {
    setIsModalForm(false);
    fetchShopInfo();
  };

  const handleSelectSetting = (key) => {
    if (key === "/logictics") {
      if (!settingData?.settingByShopId?.isUseLogistics) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "ຮ້ານນີ້ບໍ່ໄດ້ເປີດນຳໃຊ້ຂົນສົ່ງ ກະລຸນາຕິດຕໍ່ຫາທິມ ດູແລລະບົບ +856 02055936782",
          showConfirmButton: false,
          timer: 5000
        });
        return;
      }
      history.push(key);
      return;

    } {
      history.push(key);
    }
  }

  const settings = [
    {
      name: "ຕັ້ງຄ່າຂໍ້ຄວາມຕອບກັບ",
      icon: faComments,
      rounter: "/settings-facebook",
      status: false,
      disabaled: false
    },
    {
      name: "ຕັ້ງຄ່າບັນຊີທະນາຄານ",
      icon: faAddressBook,
      rounter: "/settings-bank",
      status: false,
      disabaled: false
    },
    {
      name: "ຕັ້ງຄ່າໄລຟ", icon: faVideo, rounter: "/settings-live", status: false, disabaled: false
    },
    {
      name: "ຕົວເລືອກຈັດການສິນຄ້າ",
      icon: faTruckLoading,
      rounter: "/settings-option-value",
      status: false,
      disabaled: false,
    },
    {
      name: "ຕັ້ງຄ່າເທັກ",
      icon: faTags,
      rounter: "/settings-tag",
      status: false,
      disabaled: false,
    },
    {
      name: "ຕັ້ງຄ່າເລດເງິນ",
      icon: faMoneyBill,
      rounter: "/exchange-rate",
      status: false,
      disabaled: false,
    },
    {
      name: "ຕັ້ງຄ່າບິນ",
      icon: faFileInvoice,
      rounter: "/settting-bills",
      disabaled: false,
    },
    {
      name: "ຕັ້ງຄ່າຂົນສົ່ງ",
      icon: faTruckFast,
      rounter: "/logictics",
      status: true,
      disabaled: false
    },
    {
      name: "Text To Speech",
      icon: faVoicemail,
      rounter: "/tts-cloud",
      status: false,
      disabaled: false
    },
    ...(shopData?.shop?.appV2 ? 
      [
        {
          name: "ຕັ້ງຄ່າອື່ນ",
          icon: faGear,
          rounter: "/setting-other",
          status: false,
          disabaled: false
        },{
          name: "APP V2",
          icon: faSun,
          rounter: "/setting-app-v2",
          status: true,
          disabaled: false
        }
      ] : [{
        name: "ຕັ້ງຄ່າອື່ນ",
        icon: faGear,
        rounter: "/setting-other",
        status: true,
        disabaled: false
      }])
  ];

  // update setting by shop
  if (loadingShop) return <LoadingSpinner />;

  return (
    <div>
      <div style={{ background: "#eee", height: "auto" }}>
        {shopData?.shop?.systems.includes("LIVE") ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="p-3">
              <h5 style={{ fontWeight: "bold", marginTop: 10 }}>
                ຕັ້ງຄ່າລະບົບ
              </h5>
              <div>
                ຕັ້ງຄ່າຮ້ານ, ໄລຟ, ຂໍ້ຄວາມຕອບກັບ, ຂົນສົ່ງ, ບັນຊີທະນາຄານ, ໂປຣຟາຍ,
                ປະຫວັດການອັບເດດລະບົບ...<div></div>
              </div>
            </div>
            <div className="containerSettings">
              {settings.map((setting, sIndex) => (
                <div
                  key={sIndex}
                  className="cardSetting"
                  style={{ width: width > 700 ? "25%" : "100%" }}
                  onClick={() => {
                    if (setting?.rounter === "")
                      return addToast(`ກໍາລັງພັດທະນາ`, {
                        appearance: "warning",
                        autoDismiss: true,
                      });
                    handleSelectSetting(setting?.rounter)
                  }}
                >
                  <div
                    style={{
                      padding: 10,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ fontSize: 30 }}
                        icon={setting?.icon}
                      />
                      {setting?.status ? (
                        <MdOutlineFiberNew style={{ fontSize: 36, color: 'red' }} />
                      ) : (
                        <FontAwesomeIcon
                          className="icon-tooltip"
                          style={{ fontSize: 20 }}
                          icon={faInfoCircle}
                        />
                      )}
                    </div>

                    <div style={{ fontSize: 22 }}>{setting?.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          ""
        )}
        {shopData?.shop?.systems.includes("SALE_PAGE") ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="p-3">
              <h5 style={{ fontWeight: "bold", marginTop: 10 }}>
                ຕັ້ງຄ່າເຊວເພຈ ແລະ ອື່ນໆ
              </h5>
              <div>
                ກຳນົດຄ່າຄອມມິດຊັ່ນ ສຳລັບຮ້ານ, ເປີດ-ປີດ ການສະແດງລາຄາສິນຄ້າ,
                ເປີດ-ປີດ ການນຳໃຊ້ ອາຟຣິລີເອດ
              </div>
            </div>
            <div className="containerSettings">


              <div
                className="cardSetting"
                style={{ width: width > 700 ? "25%" : "100%" }}

              >
                <div
                  style={{
                    padding: 10,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                  onClick={() => setIsOpen(true)}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >

                    <FontAwesomeIcon
                      style={{ fontSize: 30 }}
                      icon={faAddressBook}
                    />
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: 5,
                          justifyContent: "start",
                          alignItems: "start",
                          flexDirection: "column",
                        }}
                      >
                        {/* {shopData?.shop?.isUseInflu === false ? (
                          <Form.Check
                            type="switch"
                            id="custom-switch-2"
                            label={"ປີດນຳໃຊ້"}
                            checked={false}
                            onClick={handleUpdateShop}
                          />
                        ) : (
                          <Form.Check
                            type="switch"
                            id="custom-switch-2"
                            checked={true}
                            label={"ເປີດນຳໃຊ້ແລ້ວ"}
                            onClick={handleCancelInflu}
                          />
                        )} */}
                      </div>
                    </div>
                  </div>
                  <div style={{ fontSize: 22 }}>
                    Affiliater
                  </div>
                </div>
              </div>

              <div
                className="cardSetting"
                style={{ width: width > 700 ? "25%" : "100%" }}
                onClick={() => {
                  history.push("/infulancer/infulancer-link-list");
                }}
              >
                <div
                  style={{
                    padding: 10,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{ fontSize: 30 }}
                      icon={faPodcast}
                    />
                    <FontAwesomeIcon
                      className="icon-tooltip"
                      style={{ fontSize: 20 }}
                      icon={faInfoCircle}
                    />
                  </div>
                  <div style={{ fontSize: 22 }}>ສ້າງລິ້ງສຳລັບ ອາຟຣິລີເອດ</div>
                </div>
              </div>


              {shopData?.shop?.systems?.legnth <= 0 &&
                <div
                  className="cardSetting"
                  style={{ width: width > 700 ? "25%" : "100%" }}
                  onClick={() => {
                    history.push("/settings-bank");
                  }}
                >
                  <div
                    style={{
                      padding: 10,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ fontSize: 30 }}
                        icon={faAddressBook}
                      />
                      <FontAwesomeIcon
                        className="icon-tooltip"
                        style={{ fontSize: 20 }}
                        icon={faInfoCircle}
                      />
                    </div>
                    <div style={{ fontSize: 22 }}>ຕັ້ງຄ່າບັນຊີທະນາຄານ</div>
                  </div>
                </div>

              }
              {shopData?.shop?.systems?.legnth <= 0 &&
                <div
                  className="cardSetting"
                  style={{ width: width > 700 ? "25%" : "100%" }}
                  onClick={() => {
                    history.push("/settings-tag");
                  }}
                >
                  <div
                    style={{
                      padding: 10,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ fontSize: 30 }}
                        icon={faTags}
                      />
                      <FontAwesomeIcon
                        className="icon-tooltip"
                        style={{ fontSize: 20 }}
                        icon={faInfoCircle}
                      />
                    </div>
                    <div style={{ fontSize: 22 }}>ຕັ້ງຄ່າເທັກ</div>
                  </div>
                </div>

              }

              <div
                className="cardSetting"
                style={{ width: width > 700 ? "25%" : "100%" }}
                onClick={() => {
                  history.push("/settings-option-value");
                }}
              >
                <div
                  style={{
                    padding: 10,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{ fontSize: 30 }}
                      icon={faTruckLoading}
                    />
                    <FontAwesomeIcon
                      className="icon-tooltip"
                      style={{ fontSize: 20 }}
                      icon={faInfoCircle}
                    />
                  </div>
                  <div style={{ fontSize: 22 }}>ຕັ້ງຄ່າຕົວເລືອກ</div>
                </div>
              </div>

            </div>
          </div>
        ) : (
          ""
        )}
      </div>


      <Modal centered show={isModalForm} onHide={onCloseModalForm}>
        <Modal.Body>
          <CommisionPage
            noteDefault={shopData?.shop?.note}
            commisionDefault={shopData?.shop?.commision}
            closeModal={onCloseModalForm}
          />
        </Modal.Body>
      </Modal>

      {/* modal setting affiliate */}
      <Modal show={isOpen} onHide={() => setIsOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>ຕັ້ງຄ່າ Affiliater</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-4">ກຳນົດການນຳໃຊ້ ລະບົບນາຍໜ້າ ແລະ ຮູບແບບຄ່າຄອມມິດຊັ່ນ</p>

          {/* Affiliate Settings */}
          <div className="mb-4">
            <h6 className="fw-medium mb-3"></h6>
            <Row className="align-items-center">
              <Col>
                <Form.Label className="mb-1 fw-normal">{affiliateEnabled ? "ເປີດ" : "ປີດ"} ນຳໃຊ້ລະບົບ Affiliate</Form.Label>
                <div className="text-muted small">ເຂົ້າຮ່ວມກັບລະບົບນາຍໜ້າຂອງພວກເຮົາເພື່ອເພິ່ມຍອດຂາຍຫຼາຍຂື້ນ</div>
              </Col>
              <Col xs="auto">
                <Form.Check
                  type="switch"
                  id="affiliate-switch"
                  checked={affiliateEnabled}
                  onChange={(e) => setAffiliateEnabled(e.target.checked)}
                />
              </Col>
            </Row>
          </div>

          {/* Notification Settings */}
          <div className="mb-4">
            <h6 className="fw-medium mb-3"></h6>
            <Row className="align-items-center">
              <Col>
                <Form.Label className="mb-1 fw-normal">ຮູບແບບຄອມມິດຊັ່ນ</Form.Label>
                <div className="text-muted small">ຄ່າຄອມມິດຊັ່ນ ເພິ່ມ ກັບລາຄາສິນຄ້າໃນເຊວເພຈ</div>
              </Col>
              <Col xs="auto">
                <Form.Check
                  type="switch"
                  id="email-notifications-switch"
                  checked={typeCommission}
                  onChange={(e) => setTypeCommission(e.target.checked)}
                />
              </Col>
            </Row>
          </div>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setIsOpen(false)}>
            ຍົກເລີກ
          </Button>
          <Button variant="success" disabled={updateShopLoading} onClick={handleUpdateShop}>
            {updateShopLoading ? <><Spinner size="sm" /> ກຳລັງອັບເດດ</> : "ບັນທຶກ ຕັ້ງຄ່າ"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
}

export default Settings;
